import React from "react";
import {Grid} from "@mui/material";
import {BaseInput} from "../../../../designSystem/components/BaseInput";

export const TemperatureForm = ({
  measurement,
  onChangeMeasurement,
}) => (
  <Grid container spacing={2}>
    <Grid item xs={12}>
      <BaseInput
        type="number"
        onChange={e => onChangeMeasurement({...measurement, bodyTemperature: e.target.value})}
        value={measurement.bodyTemperature}
        placeholder="體溫(°C)"
      />
    </Grid>
  </Grid>
)